import { useEffect, useRef } from "react";

export const useResetEditor = ({ contractAssignmentsData, reset, isEditing }) => {
    const prevData = useRef(null); // Храним предыдущее состояние contractAssignmentsData

    useEffect(() => {
        if (!isEditing) return;
        if (contractAssignmentsData && Object.keys(contractAssignmentsData).length) {
            // Проверяем, изменилось ли только поле images или layout
            const onlyImagesOrLayoutChanged =
                prevData.current &&
                Object.keys(contractAssignmentsData).every((key) => {
                    if (key === "images" || key === "layout") {
                        return true; // Игнорируем изменения в images и layout
                    }
                    return contractAssignmentsData[key] === prevData.current[key];
                });

            // Если изменились только images или layout, пропускаем сброс
            if (onlyImagesOrLayoutChanged) {
                console.log("Skipping reset: only images or layout changed");
                prevData.current = { ...contractAssignmentsData };
                return;
            }

            // Формируем значения для сброса формы
            const formValues = {
                name: contractAssignmentsData.name || "",
                address: contractAssignmentsData.address || "",
                objectInfo: contractAssignmentsData.objectInfo || "",
                area:
                    contractAssignmentsData.area === 0
                        ? "0"
                        : contractAssignmentsData.area
                            ? String(contractAssignmentsData.area)
                            : "",
                rooms:
                    contractAssignmentsData.rooms === 0
                        ? "0"
                        : contractAssignmentsData.rooms
                            ? String(contractAssignmentsData.rooms)
                            : "",
                flatNumber: contractAssignmentsData.flatNumber || "",
                floor:
                    contractAssignmentsData.floor === 0
                        ? "0"
                        : contractAssignmentsData.floor
                            ? String(contractAssignmentsData.floor)
                            : "",
                monthlyPayment:
                    contractAssignmentsData.monthlyPayment === 0
                        ? "0"
                        : contractAssignmentsData.monthlyPayment
                            ? String(contractAssignmentsData.monthlyPayment)
                            : "",
                paidSum:
                    contractAssignmentsData.paidSum === 0
                        ? "0"
                        : contractAssignmentsData.paidSum
                            ? String(contractAssignmentsData.paidSum)
                            : "",
                fullPaymentBoughtAreaWorth:
                    contractAssignmentsData.fullPaymentBoughtAreaWorth === 0
                        ? "0"
                        : contractAssignmentsData.fullPaymentBoughtAreaWorth
                            ? String(contractAssignmentsData.fullPaymentBoughtAreaWorth)
                            : "",
                fullPaymentSellAreaWorth:
                    contractAssignmentsData.fullPaymentSellAreaWorth === 0
                        ? "0"
                        : contractAssignmentsData.fullPaymentSellAreaWorth
                            ? String(contractAssignmentsData.fullPaymentSellAreaWorth)
                            : "",
                boughtFirstPayment:
                    contractAssignmentsData.boughtFirstPayment === 0
                        ? "0"
                        : contractAssignmentsData.boughtFirstPayment
                            ? String(contractAssignmentsData.boughtFirstPayment)
                            : "",
                masterAgentMarkup:
                    contractAssignmentsData.masterAgentMarkup === 0
                        ? "0"
                        : contractAssignmentsData.masterAgentMarkup
                            ? String(contractAssignmentsData.masterAgentMarkup)
                            : "",
                isPrivate: contractAssignmentsData.isPrivate || false,
            };

            console.log("Resetting form with values:", formValues);
            reset(formValues);

            // Обновляем предыдущее состояние
            prevData.current = { ...contractAssignmentsData };
        }
    }, [contractAssignmentsData, reset]);
};
